import React from 'react';
import { Col } from '@saucelabs/sl-component-grid';

import { Price, PriceAddon } from './../Plans/Price';
import Styles from './PriceColumn.styles';

interface PriceColumnProps {
  children: React.ReactNode
  hasStartingPrice?: boolean
  price: number
}
const PriceColumn: React.FC<PriceColumnProps> = ({
  children, hasStartingPrice = true, price,
}) => (
  <Col
    className={Styles['price-container']}
    xs
  >
    <div
      className="ml-auto"
    >
      {hasStartingPrice && <div className="text-gray-600">from</div>}
      <Price>
        {`$${price}`}
        <PriceAddon> / month</PriceAddon>
      </Price>
    </div>
    <div className="mt-2">
      {children}
    </div>
  </Col>
);

export { PriceColumn };
